<template>
	<div class="detail-footer">
		<div class="m-top m-center">
			<div class="mandy-icon">
				<img src="../assets/img/madyni.png" alt="" />
				<div>
					<span>{{ info.name }}</span>
					<span>({{ info.describe }})</span>
					
				</div>
			</div>
		</div>
		<div>
			<div class="m-top m-field">
				<img src="../assets/img/message.png" alt="" />
				<span class="m-text">{{ info.email }}</span>
			</div>
			<div class="m-top m-field">
				<img src="../assets/img/stroke-1.png" alt="" />
				<span class="m-text">{{ info.mobile }}</span>
			</div>
			<div class="m-top m-field">
			<img src="../assets/img/we-chat-logo-icon-1.png" alt="" />
			<span class="m-text">{{ info.wechat }}</span>
		</div>
		</div>
		
		<div class="m-top m-center">
			<div class="qr-tip" v-if="$i18n.locale === 'en'" style="text-align:center;color:#6B7280;font-size:14px;line-height:20px;margin:0 0 8px;font-family:'Sofia Pro';">Use Wechat to scan</div>
			<div class="qr-code">
				<img :src="info.qr_code" alt="" />
			</div>
			<div v-if="$i18n.locale !== 'en'" style="text-align:center;margin:10px 0">请扫码添加顾问老师微信</div>
		</div>
		
	</div>
</template>

<script>
	import { getUser } from '../store/user';
	export default {
		name: 'WpMandy',
		data() {
			return {
				info: {
					name: '',
					describe: '',
					email: '',
					mobile: '',
					wechat: '',
					qr_code: '',
				},
			};
		},
		mounted() {
			let user = getUser();
			this.info = user.salesperson_info;
		},
	};
</script>

<style lang="less" scoped>
	.detail-footer {
		background: #FFFFFF;
        border: 1px solid rgba(0, 0, 0, 0.1);
		width: 924px;
        height: 296px;

		// text-align: center;
	}

	.mandy-icon {
		display: flex;
		flex-direction: column;
		align-items: center;
		img{
			width: 89px;
			height: 89px;
		}
		div {
			display: flex;
			flex-direction: column;
			text-align: center;
			margin-top: 9px;
			span{
				// font-weight: 600;
				font-size: 18px;
				line-height: 30px;
				color: #0B1D33;
			}
			span:nth-child(1){
				font-family: 'Poppins';
				font-style: normal;
				font-weight: 600;
				font-size: 20px;
				
			}
		}
	}

	.m-field + .m-field {
		margin-top: 40px;
	}

	.m-field {
		vertical-align: middle;
		font-family: 'Poppins';
		font-style: normal;
		font-weight: 600;
		font-size: 18px;
		line-height: 17px;
		color: #0B1D33;
		img {
			line-height: 20px;
			vertical-align: middle;
			margin-right: 10px;
		}
	}

	.detail-footer {
		margin: 30px auto 0;
		// width: 1076px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-around;
		flex-wrap: wrap;
	}
	.qr-code {
		height: 192px;
		width: 192px;
		line-height: 192px;
		background: #4b69fe;
		border-radius: 4px;
		margin: auto;
		text-align: center;
		img {
			width: 175px;
			height: 175px;
			vertical-align: middle;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/WpMandy.vue